import { createContext, useContext } from 'react';
import tinycolor, { Instance } from 'tinycolor2';

export declare type Theme = {
  logo: string;
  backgroundColor: string;
  textColor: string;
  demoMode: boolean;
  appsiteUrl: string;
  superColor: string;
};

export const ThemeContext = createContext<null | Theme>(null);

export const useTheme = () => useContext(ThemeContext);

const getHslDef = (tinycolor: Instance) => {
  const hsl = tinycolor.toHslString();
  const col = hsl.split('(')[1].split(')')[0].split(', ').join(' ');
  return col;
};

function getForeground(color: string) {
  const col = tinycolor(color);
  return col.isDark() ? '0 100% 100%' : '0 0% 0%';
}

export function setHue(hex: string, bg?: string) {
  const primary = tinycolor(hex);
  const hueTo = getHslDef(primary);
  const isDark = primary.isDark();
  if (isDark) {
    document.querySelector('html')?.classList.add('dark');
  } else {
    document.querySelector('html')?.classList.remove('dark');
  }
  const foreground = getForeground(hex);
  const diff = 40;
  let hueFrom;
  if (!bg) {
    const c2 = isDark ? primary.darken(diff) : primary.brighten(diff);
    hueFrom = getHslDef(c2);
  } else {
    const tcbg = tinycolor(bg);
    hueFrom = getHslDef(tcbg);
  }
  document.documentElement.style.setProperty('--hue-foreground', foreground);
  document.documentElement.style.setProperty('--hue-from', hueFrom);
  document.documentElement.style.setProperty('--hue-to', hueTo);
}

export function updateTheme(theme: Theme) {
  setHue(theme.backgroundColor);
  document.documentElement.style.setProperty('--customerBackground', theme.backgroundColor);
  document.documentElement.style.setProperty('--customerText', theme.textColor);
  const superHue = getHslDef(tinycolor(theme.superColor));
  document.documentElement.style.setProperty('--accent', superHue);
  document.documentElement.style.setProperty('--accent-foreground', getForeground(theme.superColor));
}
